      <!-- Step 4: Password -->
      <div *ngIf="view.currentStep === 3" class="step-password" id="wizard-step-password">
        <h1 class="step-title" id="wizard-step-password-title">{{ view.translate(view.steps[view.currentStep].title) }}</h1>
        <p class="step-description" id="wizard-step-password-description">{{ view.translate(view.steps[view.currentStep].description) }}</p>

        <form [formGroup]="view.wizardForm" class="password-form" id="wizard-password-form">
          <div class="form-group" id="wizard-password-group">
            <label for="password">{{ view.translate('invite.password') }} *</label>
            <input type="password" id="password" class="form-control" formControlName="password"
              [attr.placeholder]="view.translate('invite.password_placeholder')">
            <div *ngIf="view.wizardForm.get('password')?.invalid && view.wizardForm.get('password')?.touched" class="form-error">
              <span *ngIf="view.wizardForm.get('password')?.errors?.['required']">{{ view.translate('invite.password_required') }}</span>
              <span *ngIf="view.wizardForm.get('password')?.errors?.['minlength']">{{ view.translate('invite.password_min_length') }}</span>
            </div>
            <div class="form-text">{{ view.translate('invite.password_hint') }}</div>
          </div>

          <div class="form-group" id="wizard-confirm-password-group">
            <label for="confirmPassword">{{ view.translate('invite.confirm_password') }} *</label>
            <input type="password" id="confirmPassword" class="form-control" formControlName="confirmPassword"
              [attr.placeholder]="view.translate('invite.confirm_password_placeholder')">
            <div *ngIf="view.wizardForm.get('confirmPassword')?.touched && view.wizardForm.get('password')?.value !== view.wizardForm.get('confirmPassword')?.value" class="form-error">
              {{ view.translate('invite.passwords_not_match') }}
            </div>
          </div>
        </form>
      </div>

      <!-- Step 5: Summary / Complete -->
      <div *ngIf="view.currentStep === 4" class="step-complete" id="wizard-step-complete">
        <h1 class="step-title" id="wizard-step-complete-title">{{ view.translate(view.steps[view.currentStep].title) }}</h1>
        <p class="step-description" id="wizard-step-complete-description">{{ view.translate(view.steps[view.currentStep].description) }}</p>

        <div class="complete-illustration" id="wizard-complete-illustration">
          <i class="fas fa-check-circle" id="wizard-complete-icon"></i>
        </div>

        <div class="complete-summary" id="wizard-complete-summary">
          <h3 id="wizard-summary-title">{{ view.translate('wizard.summary_title') }}</h3>

          <div class="summary-item">
            <div class="summary-label">{{ view.translate('invite.email') }}:</div>
            <div class="summary-value">{{ view.invite?.email }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('wizard.first_name') }}:</div>
            <div class="summary-value">{{ view.wizardForm.get('firstName')?.value }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('wizard.second_name') }}:</div>
            <div class="summary-value">{{ view.wizardForm.get('secondName')?.value }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('wizard.company') }}:</div>
            <div class="summary-value">{{ view.wizardForm.get('company')?.value }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('invite.role') }}:</div>
            <div class="summary-value">{{ view.invite?.roleName }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('wizard.theme_preference') }}:</div>
            <div class="summary-value">{{ view.translate(view.wizardForm.get('theme')?.value === 'light' ? 'settings.light' : 'settings.dark') }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('wizard.language_preference') }}:</div>
            <div class="summary-value">
              {{ view.translate(
                view.wizardForm.get('language')?.value === 'es' ? 'settings.spanish' :
                view.wizardForm.get('language')?.value === 'en' ? 'settings.english' :
                view.wizardForm.get('language')?.value === 'pt' ? 'settings.portuguese' :
                view.wizardForm.get('language')?.value === 'fr' ? 'settings.french' :
                view.wizardForm.get('language')?.value === 'ja' ? 'settings.japanese' : 'settings.english'
              ) }}
            </div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('wizard.job_title') }}:</div>
            <div class="summary-value">{{ view.wizardForm.get('jobTitle')?.value }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ view.translate('wizard.timezone') }}:</div>
            <div class="summary-value">{{ view.wizardForm.get('timezone')?.value }}</div>
          </div>
        </div>

        <!-- Error message -->
        <div class="alert alert-danger" *ngIf="view.errorMessage" id="wizard-complete-error">
          <i class="fas fa-exclamation-triangle"></i> {{ view.errorMessage }}
        </div>
      </div>
